import React from 'react'
import Details from './Details'
import './Tearms&Conditions.css'
import Terms from './Terms'

const TermsConditions = () => {
  return (
    <>
        <Terms />
        <Details />
    </>
  )
}

export default TermsConditions